import a from "./arrayLikeToArray.js";
function i(r, e) {
  if (!!r) {
    if (typeof r == "string")
      return a(r, e);
    var t = Object.prototype.toString.call(r).slice(8, -1);
    if (t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set")
      return Array.from(r);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return a(r, e);
  }
}
export {
  i as default
};
//# sourceMappingURL=unsupportedIterableToArray.js.map
